$w.onReady(() => {

    waitForLoading();

});

 

export function button6_onClick(event) {

    $w('#preloader').show();

    waitForLoading();

}

 

function waitForLoading() {

    setTimeout(() => {

        $w('#preloader').hide('FadeOut');

    }, 1500);

}
// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window'
import window from 'wix-window'

$w.onReady(function () {
	//TODO: write your page related code here...

});
export function button10_onMouseIn(event) {
  window.openLightbox('About Us LB');
}
export function lightbox1_mouseOut(event) {
	//Add your code for this event here: 
	wixWindow.lightbox.close();
}

$w.onReady(() => {

    waitForLoading();

});